/**
 * Progressive-enhancement custom dropdown for the desktop "Ordenar por"
 * sort control. The real <select> stays in the DOM and fully functional
 * (facets.js keeps listening to it exactly as before) -- this just adds a
 * styled trigger + panel on top that sets the select's value and fires a
 * native change event, so nothing about the actual sorting/filtering logic
 * changes.
 */
(function () {
  var SORT_ICONS = {
    manual:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17.3l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3.5z"/></svg>',
    'created-descending':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M8 3v4M16 3v4M3.5 9.5h17"/></svg>',
    'price-descending':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5v19M16.5 6.8c0-1.8-2-2.8-4.5-2.8s-4.5 1-4.5 3.1c0 4.2 9 1.9 9 6.1 0 2.1-2 3.1-4.5 3.1s-4.5-1-4.5-2.8"/></svg>',
    'price-ascending':
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="11" cy="13" rx="7.5" ry="5.5"/><ellipse cx="18" cy="13.5" rx="1.6" ry="1.2" fill="currentColor" stroke="none"/><circle cx="8" cy="11" r="0.7" fill="currentColor" stroke="none"/><path d="M6 8c-1-1-1-2.2 0-3 .8 1 1.6 1.6 2.4 1.8"/><path d="M4 12c-1 0-1.8-.6-2-1.6"/><path d="M7 18.3v2M10 18.6v2M14 18.6v2M17 18v2"/><path d="M10.5 7.3h2"/></svg>',
  };

  function enhance(wrapper) {
    if (wrapper.dataset.customSortInit) return;
    var select = wrapper.querySelector('select[name="sort_by"]');
    if (!select) return;
    wrapper.dataset.customSortInit = 'true';

    select.classList.add('visually-hidden');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'custom-sort-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerLabel = document.createElement('span');
    trigger.appendChild(triggerLabel);

    var caretHolder = wrapper.querySelector('.svg-wrapper');
    if (caretHolder) {
      trigger.appendChild(caretHolder.cloneNode(true));
      caretHolder.classList.add('visually-hidden');
    }

    var panel = document.createElement('ul');
    panel.className = 'custom-sort-panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    function setTriggerText() {
      var selected = select.options[select.selectedIndex];
      triggerLabel.textContent = selected ? selected.textContent.trim() : '';
    }

    function close() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    function open() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    Array.prototype.forEach.call(select.options, function (option) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-sort-option';
      var iconMarkup = SORT_ICONS[option.value];
      if (iconMarkup) {
        var iconHolder = document.createElement('span');
        iconHolder.className = 'custom-sort-option-icon';
        iconHolder.innerHTML = iconMarkup;
        btn.appendChild(iconHolder);
      }
      var labelSpan = document.createElement('span');
      labelSpan.className = 'custom-sort-option-label';
      labelSpan.textContent = option.textContent.trim();
      btn.appendChild(labelSpan);
      btn.setAttribute('role', 'option');
      if (option.selected) {
        btn.classList.add('is-selected');
        btn.setAttribute('aria-selected', 'true');
      }
      btn.addEventListener('click', function () {
        select.value = option.value;
        // facets.js listens for 'input' bubbling up to the form (not
        // 'change'), so both are fired to cover any listener bound either way.
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        setTriggerText();
        panel.querySelectorAll('.custom-sort-option').forEach(function (b) {
          var isSelected = b === btn;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });
        close();
        trigger.focus();
      });
      li.appendChild(btn);
      panel.appendChild(li);
    });

    trigger.addEventListener('click', function () {
      if (panel.hidden) {
        open();
      } else {
        close();
      }
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    setTriggerText();
    wrapper.classList.add('custom-sort-wrapper');
    wrapper.appendChild(trigger);
    wrapper.appendChild(panel);
  }

  function init() {
    document.querySelectorAll('.facet-filters.sorting .select, .mobile-facets__sort .select').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify's facets/section-rendering machinery replaces chunks of this
  // page's DOM at various points (on filter/sort changes, and apparently on
  // some initial sync too), which wipes out any enhancement made to elements
  // inside the replaced area. Re-apply on any DOM change we can observe...
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      init();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ...and, since the exact replacement isn't reliably caught by the
  // observer alone, also poll as a safety net. init() is a cheap no-op for
  // wrappers already enhanced, so this is safe to run indefinitely.
  setInterval(init, 500);
})();
